import { render, staticRenderFns } from "./IntegratedSearchList.vue?vue&type=template&id=5fed15a2&scoped=true&"
import script from "./IntegratedSearchList.vue?vue&type=script&lang=js&"
export * from "./IntegratedSearchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fed15a2",
  null
  
)

component.options.__file = "IntegratedSearchList.vue"
export default component.exports